const routes = {
  LOGIN: "/login",
  TWO_FACTOR_LOGIN: "/2factorlogin",
  CONDITIONS: "/termsandconditions",
  DASHBOARD: "/",
  LIMITS: "/feesandlimits",
  PASSCODE: "/passcode",
  REPORT: "/report",
  SUCCESSFUL: "/successful",
  PAGES: "/pages",
  PROFILE: "/myprofile",
  BONUSES: "/mybonuses",
  TRANSACTIONS: "/transactions",
  NOTIFICATIONS: "/notifications",
  POSTS: "/posts",
  FORGOTTENPASS: "/forgotPassword",
  SETNEWPASS: "/setPassword",
  CONFIRMREG: "/confirmRegistration",
  FREEZECARD: "/freezecard",
  MYVEHICLE: "/myvehicle",
  PRIVACY: "/privacypolicy"
};

export default routes;
